var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173079",
    "data-name": "Group 173079",
    transform: "translate(10) rotate(90)",
    opacity: 0.699
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11767",
    "data-name": "Group 11767",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11553",
    "data-name": "Path 11553",
    d: "M4,19.333H14V18H4Z",
    transform: "translate(-4 -15.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11554",
    "data-name": "Path 11554",
    d: "M8.583,9H4v1.333H14V9H8.583Z",
    transform: "translate(-4 -9)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragger);
export default __webpack_public_path__ + "static/media/Dragger.e0197ac2741d508417d2ae34e8150ac9.svg";
export { ForwardRef as ReactComponent };